export const validateEmail = (toTest:any):boolean=> {
    return typeof(toTest) !== "string"
        ? false
        : /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/g.test(toTest.toLowerCase());
}

export const validateOtp = (toTest:any):boolean => {
    return typeof(toTest) !== "string"
        ? false
        :  /\d{6}/g.test(toTest);
}

export const validateDateString = (toTest:any):boolean => {
    return typeof(toTest) !== "string"
        ? false
        : !isNaN(new Date(toTest).getTime());
}
